import { Component, OnInit } from '@angular/core';
import { Project } from '../../objects/Project'; // Import the Project interface or class
import { ProjectService } from '../../Services/project.services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-grid',
  templateUrl: './project-grid.component.html',
  styleUrls: ['./project-grid.component.css']
})
export class ProjectGridComponent implements OnInit {
  projects: Project[] = [];
  isMobile = false;
  searchTerm = '';
  isDrawerOpened = true;

  constructor(private projectService: ProjectService,
    
    private router: Router) {}

  ngOnInit() {
    this.loadProjects();
    this.checkisMobile();
  }

  loadProjects() {
    this.projectService.getProjects().subscribe((projects) => {
      this.projects = (projects || []).sort((a, b) => a.priority - b.priority);
    });
  }

  confirmDeleteProject(project: Project) {
    const ok = confirm(`Delete project "${project.title}"? This cannot be undone.`);
    if (!ok) { return; }
    this.projectService.deleteProject(project.id!).subscribe({
      next: () => {
        this.projects = this.projects.filter(p => p.id !== project.id);
      },
      error: (err) => {
        console.error('Failed to delete project', err);
        alert('Failed to delete project. Please try again.');
      }
    });
  }

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
      this.isDrawerOpened = false
    }
      else
    {this.isMobile = false;}
    
    
  } 
  
  editProject(project: Project) {
    // Implement the edit functionality here
    
    this.router.navigate(['projects/edit/', project.id]);
    // You can open a dialog or navigate to a separate edit page with the material's data
    console.log('Editing project:', project);
  }

  // Add these getters/helpers
  get filteredProjects(): any[] {
    if (!this.searchTerm.trim()) return this.projects || [];
    const term = this.searchTerm.toLowerCase();
    return (this.projects || []).filter(p =>
      p.title?.toLowerCase().includes(term) ||
      p.projectDescription?.toLowerCase().includes(term)
    );
  }

  get activeProjects(): any[] {
    return this.filteredProjects.filter(p => p.isActive === true && !p.isComplete);
  }

  get pendingProjects(): any[] {
    return this.filteredProjects.filter(p => !p.isActive && !p.isComplete);
  }

  get completedProjects(): any[] {
    return this.filteredProjects.filter(p => p.isComplete === true);
  }

  getPercent(project: any): number {
    const total = Number(project?.totalProjectPrice) || 0;
    const current = Number(project?.currentProjectPrice) || 0;
    if (total <= 0) {
      return 0;
    }
    // clamp to 0..1 range
    const percent = current / total;
    return percent < 0 ? 0 : percent > 1 ? 1 : percent;
  }
}
